import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { LOGIN_PATH } from '../config/paths';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
          gap: 3,
        }}
      >
        <Typography variant="h4" color="error" sx={{ fontWeight: 700 }}>
          Unauthorized
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
          }}
        >
          You do not have permission to view this page or your session has
          expired.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(LOGIN_PATH)}
          sx={{ py: 1.5, px: 4, borderRadius: 2, fontWeight: 600 }}
        >
          Go to the Login page
        </Button>
      </Box>
    </Container>
  );
};

export default UnauthorizedPage;
